import { Component, Input } from '@angular/core';
import { DefaultLayoutDirective } from '../../../flex-layout/custom-layout';
import { NgStyle } from '@angular/common';
import { DefaultStyleDirective } from '../../../flex-layout/style';
import { EditorTextComponent } from '../editor-text/editor-text.component';
import { NgOptimizedImageComponent } from '../ng-optimized-image/ng-optimized-image.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'calsoft-image-contact-form',
  imports: [DefaultLayoutDirective, NgStyle, DefaultStyleDirective, EditorTextComponent, NgOptimizedImageComponent],
  templateUrl: './image-contact-form.component.html',
  styleUrl: './image-contact-form.component.scss'
})
export class ImageContactFormComponent {

   public serverPath = environment.commonImageApi + '/commonSlider/';

  public serverPath1 = environment.commonImageApi + '/home/';

  @Input() item: any;

  @Input() img: any;
  @Input() data: any;
}
